import React, { useState, useEffect } from 'react';
import Loader from '../../../components/Loader/Loader';
import '../TruNorthDashboard/TruNorthDashboard.less';
import { handleZoom } from '../../../libs/helper/HelperFunctions';
import {
  IVisitedPagePayload,
  SectionType,
  TrafficAnalyticsActions,
} from '../../../libs/store/actions/WebAnalytics/TrafficAnalyticsActions';
import { useDispatch } from 'react-redux';
import { IProduct } from '../../../libs/models/cbo/EngagementModels';
import { useAppSelector, IApplicationState } from '../../../libs/store/reducers';

interface IAssetProps {
  selectedAssetConfig?: IProduct;
  isEngagement?: boolean;
  selectedEnagagementName?: string;
  selectedEnagagementId?: string;
  selectedClientName?: string;
}

const DigitalTesterDashboard = ({
  isEngagement,
  selectedAssetConfig,
  selectedEnagagementName,
  selectedEnagagementId,
  selectedClientName,
}: IAssetProps) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const dispatcher = {
    postPageVisited: (data: IVisitedPagePayload) =>
      dispatch(TrafficAnalyticsActions.postVisitedPageStart(data)),
  };
  const { KeyAssetDefaultList } = useAppSelector((state: IApplicationState) => ({
          KeyAssetDefaultList: state.engagement.KeyAssetDefaultList,
        }));
    const selectedAssetConfigDefault = KeyAssetDefaultList?.find(
        (keyAsset) => keyAsset.product?.toLowerCase() === selectedAssetConfig?.product.toLowerCase(),
    );

  useEffect(() => {
    handleZoom('assess-iframe');
    dispatcher.postPageVisited({
      sectionType: isEngagement ? SectionType.ENG_ASSET : SectionType.PURSUIT_ASSET,
      assetName: SectionType.DIGITALTESTER,
      id: selectedEnagagementId,
      name: selectedEnagagementName,
      clientName: selectedClientName,
    });
    return () => {
      dispatcher.postPageVisited({
        sectionType: isEngagement ? SectionType.ENG_ASSET : SectionType.PURSUIT_ASSET,
        assetName: SectionType.DIGITALTESTER,
        id: selectedEnagagementId,
        name: selectedEnagagementName,
        clientName: selectedClientName,
      });
    };
  }, []);

  return (
    <div className="trunorth-dashboard-wrapper">
      <Loader loaderName="Authorizing..." loading={isLoading}>
        <iframe
          id="assess"
          className="assess-iframe"
          title="Assess"
          src={
            isEngagement
              ? selectedAssetConfig?.instanceUrl
              : selectedAssetConfig?.configDone
                ? selectedAssetConfig?.instanceUrl
                : selectedAssetConfigDefault?.instanceUrl
          }
          onLoad={() => setIsLoading(false)}
        />
      </Loader>
    </div>
  );
};

export default DigitalTesterDashboard;
